import ModuleView from "@/components/shieldx/ModuleView";
import { ScanSearch } from "lucide-react";
export default function ShadowAI() {
  return <ModuleView name="shadow-ai" icon={ScanSearch} />;
}
